import { get } from "lodash";
import { DEFAULT_MAX_INSTANCES } from "@searchui-searchforms/shared/constants";
import { useFormStore } from "@/widgets/classic-form/form";
import type { RelationshipFieldset } from "@/entities/form-metadata";

interface UseIsNewRelationshipEnabledProps {
    fieldset: RelationshipFieldset;
}

export const useIsNewRelationshipEnabled = ({ fieldset }: UseIsNewRelationshipEnabledProps) =>
    useFormStore(({ values }) => {
        const instances = get(values, `family.${fieldset.relation.toLowerCase()}.instances`, []);
        const currentItemCount = instances.length;

        return currentItemCount >= (fieldset.maxInstances ?? DEFAULT_MAX_INSTANCES);
    });
